








































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddFreight {
        warehouseInfoId: number;
        site: number;
        beginTime?: Date;
        endTime?: Date;
        isEffective: boolean;
        bulkyParameter: number;
    }
    @Component
    export default class CreatefreightModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        freight: AddFreight = new AddFreight();
        selectDate: string = "";
        selectDates: string = "";
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        cargoCategoryType = Enums.CargoCategoryType;
        siteType = Enums.SiteSType;
        addLoding = false;
        amountTotal: string = '';;
        created() {
            this.getCity();
        }
        //async calculation() {
        //    //var total = Math.ceil((that.inputweight - that.firstWeight) / that.continueWeight) * that.continueWeightCost + that.firstWeightPrice;
        //    await this.$store.dispatch({
        //        type: 'mainlandfeightinfo/GetFreight',
        //        data: this.freight
        //    })
        //    this.amountTotal = this.$store.state.mainlandfeightinfo.total;
        //}
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'thirdpartyparameter/Add',
                        data: this.freight
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.freightCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.freight.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.freightCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        freightRule = {
            bulkyParameter: [
                { required: true, message: '体积重参数不能为空', trigger: 'blur' }
            ],
            beginTime: [
                { required: true, message: '开始时间不能为空', trigger: 'change', type: 'date' }
            ],
            endTime: [
                { required: true, message: '结束时间不能为空', trigger: 'change', type: 'date' }
            ],
        };

    }
